var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a-layout',[_c('Header'),_c('a-layout',{attrs:{"id":"components-layout-demo-custom-trigger"}},[_c('Sider'),_c('a-layout',{staticClass:"section"},[_c('a-layout-content',{style:({
            margin: '24px 16px',
            padding: '24px',
            marginTop: '24px',
            background: '#fff',
            minHeight: '280px',
          })},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }